import styles from "./LargeButton.module.css";

const LargeButton = ({ children, ...props }) => {
    return <button {...props}>{children}</button>;
};

export default LargeButton;
